var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _linearGradient14, _linearGradient15, _linearGradient16, _linearGradient17, _linearGradient18, _linearGradient19, _linearGradient20, _linearGradient21, _linearGradient22, _linearGradient23, _linearGradient24, _linearGradient25, _linearGradient26, _linearGradient27, _linearGradient28, _linearGradient29, _linearGradient30, _linearGradient31, _linearGradient32, _linearGradient33, _linearGradient34, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconMaracas(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 510 510",
    height: 512,
    viewBox: "0 0 510 510",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f6a96c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ca6e59"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientTransform: "matrix(0 1 1 0 -187.916 187.916)",
    gradientUnits: "userSpaceOnUse",
    x1: 213.446,
    x2: 213.446,
    xlinkHref: "#lg1",
    y1: 497.242,
    y2: 566.339
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg2"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ca6e59",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3856,
    stopColor: "#aa5844",
    stopOpacity: 0.386
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7675,
    stopColor: "#914634",
    stopOpacity: 0.768
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#883f2e"
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 439.075,
    x2: 300.531,
    xlinkHref: "#lg2",
    y1: 405.42,
    y2: 266.876
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg3"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fe646f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fb2b3a"
  }))), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 325.298,
    x2: 386.857,
    xlinkHref: "#lg3",
    y1: 269.723,
    y2: 331.283
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg4"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c0272d",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c0272d"
  }))), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 394.677,
    x2: 350.677,
    xlinkHref: "#lg4",
    y1: 398.688,
    y2: 272.688
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg5"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fe9738"
  }))), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 262.155,
    x2: 452.436,
    xlinkHref: "#lg5",
    y1: 50.574,
    y2: 240.856
  })), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg6"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fe9738",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fe7701"
  }))), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 389.505,
    x2: 264.505,
    xlinkHref: "#lg6",
    y1: 175.685,
    y2: 175.685
  })), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg7"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#22b27f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#017b4e"
  }))), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 355.495,
    x2: 355.495,
    xlinkHref: "#lg7",
    y1: 97.579,
    y2: 179.224
  })), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 408.55,
    x2: 289.884,
    y1: 203.464,
    y2: 139.131
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#017b4e",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6213,
    stopColor: "#017147",
    stopOpacity: 0.621
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#026841"
  }))), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg8"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#537983"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3e5959"
  }))), _linearGradient17 || (_linearGradient17 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 296.919,
    x2: 296.919,
    xlinkHref: "#lg8",
    y1: 75.39,
    y2: 109.625
  })), _linearGradient18 || (_linearGradient18 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 319.544,
    x2: 294.976,
    y1: 124.294,
    y2: 99.726
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3e5959",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#444"
  }))), _linearGradient19 || (_linearGradient19 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 414.071,
    x2: 414.071,
    xlinkHref: "#lg8",
    y1: 75.39,
    y2: 109.625
  })), _linearGradient20 || (_linearGradient20 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 355.495,
    x2: 355.495,
    xlinkHref: "#lg3",
    y1: 133.109,
    y2: 211.944
  })), _linearGradient21 || (_linearGradient21 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 406.32,
    x2: 274.987,
    xlinkHref: "#lg4",
    y1: 212.826,
    y2: 154.492
  })), _linearGradient22 || (_linearGradient22 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 355.495,
    x2: 355.495,
    xlinkHref: "#lg6",
    y1: 240.384,
    y2: 282.81
  })), _linearGradient23 || (_linearGradient23 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: 355.495,
    x2: 355.495,
    xlinkHref: "#lg2",
    y1: 467,
    y2: 507.112
  })), _linearGradient24 || (_linearGradient24 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientTransform: "matrix(0 1 1 0 -187.916 187.916)",
    gradientUnits: "userSpaceOnUse",
    x1: 213.446,
    x2: 213.446,
    xlinkHref: "#lg1",
    y1: 296.252,
    y2: 365.349
  })), _linearGradient25 || (_linearGradient25 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientUnits: "userSpaceOnUse",
    x1: 238.085,
    x2: 99.541,
    xlinkHref: "#lg2",
    y1: 405.42,
    y2: 266.876
  })), _linearGradient26 || (_linearGradient26 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_",
    gradientUnits: "userSpaceOnUse",
    x1: 124.308,
    x2: 185.867,
    xlinkHref: "#lg3",
    y1: 269.723,
    y2: 331.283
  })), _linearGradient27 || (_linearGradient27 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_19_",
    gradientUnits: "userSpaceOnUse",
    x1: 193.687,
    x2: 149.687,
    xlinkHref: "#lg4",
    y1: 398.688,
    y2: 272.688
  })), _linearGradient28 || (_linearGradient28 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_20_",
    gradientUnits: "userSpaceOnUse",
    x1: 61.165,
    x2: 251.447,
    xlinkHref: "#lg5",
    y1: 50.574,
    y2: 240.856
  })), _linearGradient29 || (_linearGradient29 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_21_",
    gradientUnits: "userSpaceOnUse",
    x1: 154.505,
    x2: 154.505,
    xlinkHref: "#lg7",
    y1: 97.579,
    y2: 179.224
  })), _linearGradient30 || (_linearGradient30 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_22_",
    gradientUnits: "userSpaceOnUse",
    x1: 95.929,
    x2: 95.929,
    xlinkHref: "#lg8",
    y1: 75.39,
    y2: 109.625
  })), _linearGradient31 || (_linearGradient31 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_23_",
    gradientUnits: "userSpaceOnUse",
    x1: 213.081,
    x2: 213.081,
    xlinkHref: "#lg8",
    y1: 75.39,
    y2: 109.625
  })), _linearGradient32 || (_linearGradient32 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_24_",
    gradientUnits: "userSpaceOnUse",
    x1: 154.505,
    x2: 154.505,
    xlinkHref: "#lg3",
    y1: 133.109,
    y2: 211.944
  })), _linearGradient33 || (_linearGradient33 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_25_",
    gradientUnits: "userSpaceOnUse",
    x1: 154.505,
    x2: 154.505,
    xlinkHref: "#lg6",
    y1: 240.384,
    y2: 282.81
  })), _linearGradient34 || (_linearGradient34 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_26_",
    gradientUnits: "userSpaceOnUse",
    x1: 154.505,
    x2: 154.505,
    xlinkHref: "#lg2",
    y1: 467,
    y2: 507.112
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m355.495 510c-26.408 0-48.548-20.002-51.156-46.281-1.083-10.916-1.659-22.358-1.659-34.15 0-75.578 23.646-136.845 52.815-136.845s52.815 61.268 52.815 136.845c0 11.792-.576 23.234-1.659 34.15-2.608 26.279-24.748 46.281-51.156 46.281z",
    fill: "url(#SVGID_1_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m355.495 292.724c-13.243 0-25.347 12.63-34.617 33.493l87.057 87.057c-3.11-67.895-25.4-120.55-52.44-120.55z",
    fill: "url(#SVGID_2_)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 355.495,
    cy: 299.92,
    fill: "url(#SVGID_3_)",
    rx: 54.735,
    ry: 33.609
  }), /*#__PURE__*/React.createElement("path", {
    d: "m355.495 266.311c-23.135 0-42.903 8.818-50.914 21.275l45.792 45.792c1.687.096 3.394.151 5.122.151 30.229 0 54.735-15.047 54.735-33.609s-24.506-33.609-54.735-33.609z",
    fill: "url(#SVGID_4_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m487.431 131.936c0 72.866-59.07 171.972-131.936 171.972s-131.936-99.106-131.936-171.972 59.07-131.936 131.936-131.936 131.936 59.07 131.936 131.936z",
    fill: "url(#SVGID_5_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m450.385 242.95c-23.99 35.06-57.64 60.96-94.89 60.96-14 0-27.5-3.66-40.16-10.1-.46-.23-.93-.47-1.39-.71-.42-.22-.85-.45-1.27-.68-22.48-12.21-42.22-33.13-57.38-57.62-19.44-31.43-31.32-68.76-31.73-101.15 0-.36-.01-.72-.01-1.08.09-32.47 11.91-62.18 31.44-85.11 0 0 151.77 152 195.39 195.49z",
    fill: "url(#SVGID_6_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m452.548 108.81-20.176 20.176c-10.439 10.439-27.363 10.439-37.802 0l-20.176-20.176c-10.439-10.438-27.363-10.438-37.802 0l-20.176 20.176c-10.439 10.439-27.363 10.439-37.802 0l-20.176-20.176c-8.67-8.67-21.813-10.131-31.999-4.398-1.884 8.879-2.884 18.084-2.884 27.525 0 3.754.165 7.58.473 11.456 10.44-7.457 25.038-6.506 34.41 2.866l20.176 20.176c10.439 10.439 27.363 10.439 37.802 0l20.176-20.176c10.439-10.438 27.363-10.438 37.802 0l20.176 20.176c10.439 10.439 27.363 10.439 37.802 0l20.176-20.176c9.372-9.372 23.97-10.323 34.41-2.866.307-3.876.473-7.702.473-11.456 0-9.44-.999-18.646-2.884-27.525-10.186-5.733-23.328-4.272-31.999 4.398z",
    fill: "url(#SVGID_7_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m326.425 118.979-10.007 10.007c-10.439 10.439-27.363 10.439-37.802 0l-20.175-20.176c-8.67-8.67-21.813-10.131-31.999-4.398-1.884 8.879-2.884 18.084-2.884 27.525 0 3.754.165 7.58.473 11.456 10.44-7.457 25.038-6.506 34.41 2.866l20.175 20.176c10.439 10.439 27.363 10.439 37.802 0l20.176-20.176c3.076-3.076 6.718-5.239 10.589-6.502-7.035-7.041-13.996-14.009-20.758-20.778z",
    fill: "url(#SVGID_8_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 296.919,
    cy: 92.181,
    fill: "url(#SVGID_9_)",
    r: 15.364
  }), /*#__PURE__*/React.createElement("path", {
    d: "m287.529 80.038c-3.629 2.81-5.974 7.198-5.974 12.142 0 8.485 6.879 15.364 15.364 15.364 4.938 0 9.321-2.339 12.131-5.96-7.741-7.748-14.99-15.006-21.521-21.546z",
    fill: "url(#SVGID_10_)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 414.071,
    cy: 92.181,
    fill: "url(#SVGID_11_)",
    r: 15.364
  })), /*#__PURE__*/React.createElement("path", {
    d: "m452.548 144.176-20.176 20.176c-10.439 10.439-27.363 10.439-37.802 0l-20.176-20.176c-10.439-10.439-27.363-10.439-37.802 0l-20.176 20.176c-10.439 10.439-27.363 10.439-37.802 0l-20.176-20.176c-9.415-9.415-24.105-10.335-34.555-2.766.736 11.097 2.724 22.65 5.822 34.257 9.606-3.793 20.964-1.811 28.732 5.957l20.176 20.176c10.439 10.439 27.363 10.439 37.802 0l20.176-20.176c10.439-10.439 27.363-10.439 37.802 0l20.176 20.176c10.439 10.439 27.363 10.439 37.802 0l20.176-20.176c7.768-7.768 19.127-9.751 28.732-5.957 3.098-11.607 5.087-23.16 5.822-34.257-10.448-7.568-25.137-6.649-34.553 2.766z",
    fill: "url(#SVGID_12_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m345.651 138.224c-3.298 1.304-6.39 3.285-9.057 5.953l-20.176 20.176c-10.439 10.439-27.363 10.439-37.802 0l-20.175-20.176c-9.415-9.415-24.105-10.335-34.555-2.766.736 11.097 2.724 22.65 5.822 34.257 9.606-3.793 20.964-1.811 28.732 5.957l20.175 20.176c10.439 10.439 27.363 10.439 37.802 0l20.176-20.176c10.439-10.439 27.363-10.439 37.802 0l20.176 20.176c6.07 6.07 14.333 8.603 22.239 7.614-20.907-20.903-46.521-46.533-71.159-71.191z",
    fill: "url(#SVGID_13_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m242.795 211.576c23.167 49.814 64.973 92.333 112.7 92.333s89.533-42.519 112.7-92.333z",
    fill: "url(#SVGID_14_)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m302.759 436c.17 9.522.696 18.803 1.581 27.719 2.607 26.279 24.747 46.281 51.155 46.281 26.408 0 48.548-20.002 51.156-46.281.885-8.916 1.41-18.197 1.581-27.719z",
    fill: "url(#SVGID_15_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m154.505 510c-26.408 0-48.548-20.002-51.156-46.281-1.083-10.916-1.659-22.358-1.659-34.15 0-75.578 23.646-136.845 52.815-136.845s52.815 61.268 52.815 136.845c0 11.792-.576 23.234-1.659 34.15-2.608 26.279-24.748 46.281-51.156 46.281z",
    fill: "url(#SVGID_16_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m154.505 292.724c-13.243 0-25.347 12.63-34.617 33.493l87.057 87.057c-3.109-67.895-25.4-120.55-52.44-120.55z",
    fill: "url(#SVGID_17_)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 154.505,
    cy: 299.92,
    fill: "url(#SVGID_18_)",
    rx: 54.735,
    ry: 33.609
  }), /*#__PURE__*/React.createElement("path", {
    d: "m154.505 266.311c-23.135 0-42.903 8.818-50.914 21.275l45.792 45.792c1.687.096 3.394.151 5.122.151 30.229 0 54.735-15.047 54.735-33.609s-24.506-33.609-54.735-33.609z",
    fill: "url(#SVGID_19_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m286.441 131.936c0 72.866-59.07 171.972-131.936 171.972s-131.936-99.105-131.936-171.972 59.07-131.936 131.936-131.936 131.936 59.07 131.936 131.936z",
    fill: "url(#SVGID_20_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m251.558 108.81-20.176 20.176c-10.439 10.439-27.363 10.439-37.802 0l-20.176-20.176c-10.439-10.438-27.363-10.438-37.802 0l-20.176 20.176c-10.439 10.439-27.363 10.439-37.802 0l-20.172-20.176c-8.67-8.67-21.813-10.131-31.999-4.398-1.884 8.879-2.884 18.084-2.884 27.525 0 3.754.165 7.58.473 11.456 10.44-7.457 25.038-6.506 34.41 2.866l20.176 20.176c10.439 10.439 27.363 10.439 37.802 0l20.176-20.176c10.439-10.438 27.363-10.438 37.802 0l20.176 20.176c10.439 10.439 27.363 10.439 37.802 0l20.176-20.176c9.372-9.372 23.97-10.323 34.41-2.866.307-3.876.473-7.702.473-11.456 0-9.44-.999-18.646-2.884-27.525-10.19-5.733-23.332-4.272-32.003 4.398z",
    fill: "url(#SVGID_21_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 95.929,
    cy: 92.181,
    fill: "url(#SVGID_22_)",
    r: 15.364
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 213.081,
    cy: 92.181,
    fill: "url(#SVGID_23_)",
    r: 15.364
  })), /*#__PURE__*/React.createElement("path", {
    d: "m251.558 144.176-20.176 20.176c-10.439 10.439-27.363 10.439-37.802 0l-20.176-20.176c-10.439-10.439-27.363-10.439-37.802 0l-20.176 20.176c-10.439 10.439-27.363 10.439-37.802 0l-20.176-20.176c-9.415-9.415-24.105-10.335-34.555-2.766.736 11.097 2.724 22.65 5.822 34.257 9.606-3.793 20.964-1.811 28.732 5.957l20.18 20.176c10.439 10.439 27.363 10.439 37.802 0l20.176-20.176c10.439-10.439 27.363-10.439 37.802 0l20.176 20.176c10.439 10.439 27.363 10.439 37.802 0l20.176-20.176c7.768-7.768 19.127-9.751 28.733-5.957 3.098-11.607 5.087-23.16 5.822-34.257-10.453-7.568-25.142-6.649-34.558 2.766z",
    fill: "url(#SVGID_24_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m41.805 211.576c23.167 49.814 64.973 92.333 112.7 92.333s89.533-42.519 112.7-92.333z",
    fill: "url(#SVGID_25_)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m101.769 436c.17 9.522.696 18.803 1.581 27.719 2.607 26.279 24.747 46.281 51.155 46.281 26.408 0 48.548-20.002 51.156-46.281.885-8.916 1.41-18.197 1.581-27.719z",
    fill: "url(#SVGID_26_)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMaracas);
export default __webpack_public_path__ + "static/media/icon-maracas.24fb9daa64cc05cfb4a7eae8b7c8f915.svg";
export { ForwardRef as ReactComponent };